import { Stack } from "@mui/material";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { SettingsItem } from "Components/Settings/SettingsItem/SettingsItem";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { useMenuLinks } from "Hooks/Layout/useMenuLinks";
import { Resources, useResource } from "Translations/Resources";

export const AmlDashboardPage = () => {
  const { t } = useResource();
  const { amlUsers, merchants } = useMenuLinks();

  const quickLinks = [amlUsers, merchants];

  return (
    <AuthenticatedLayout title={t(Resources.Pages.Titles.Dashboard)}>
      <StyledPageWrapper>
        <Stack className="left-content">
          {quickLinks.map((link) => (
            <SettingsItem link={link} key={link.text} />
          ))}
        </Stack>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default AmlDashboardPage;
